import { z } from "zod";

export const GetAllRequestsInputSchema = z.object({
    userName: z.string().nullish(),
    searchQuery: z.string().nullish(),
    filterQuery: z.string().nullish(),
    requestIds: z.array(z.string()).nullish(),
    order: z.string().nullish(),
    limit: z.number().nullish(),
    page: z.number().nullish(),
});

export type GetAllRequestsInput = z.infer<typeof GetAllRequestsInputSchema>;